// extracted by mini-css-extract-plugin
export var planCard = "_sm-0";
export var planList = "_sm-1";